import { Layout } from './components';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux';
import store from '@/store'
import './App.scss';
function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <div className="App">
          <Layout />
        </div>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
